import { connect } from 'react-redux'
import Sidebar from './Sidebar'

const mapStateToProps = (state) => ({
  subInvoice: state.screens.SubInvoice.subInvoice,
})

const actionCreators = {
}

export default connect(mapStateToProps, actionCreators)(Sidebar)
